import mixins from 'vue-typed-mixins';

import RoomMixin from '@/user/mixins/RoomMixin';
import { PublicRoutes } from '@/user/router/AppRouteConfig';
import { PUBLIC_PATH } from '@/classes/common/Constants';



export default mixins(RoomMixin).extend({

  name: 'User',

  // vue-head
  head: {
    title(): Object {
      return { inner: this.createHtmlTitle() };
    },
    link(): Object[] {
      const links = [];
      links.push({ rel: 'preload', as: 'font', type: 'font/ttf', href: require('@/assets/font/MTkjk4.ttf') });
      links.push({ rel: 'stylesheet', href: `${PUBLIC_PATH}resource/user/css/color.css`, id: 'color' });
      links.push({ rel: 'shortcut icon', href: `${PUBLIC_PATH}resource/user/icon/favicon.ico`, id: 'icon' });
      if (this.resourceName.length > 0) {
        // links.push({ rel: 'shortcut icon', href: `${PUBLIC_PATH}resource/user/icon/favicon_${this.resourceName}.ico`, id: 'icon' });
        // links.push({ rel: 'stylesheet',    href: `${PUBLIC_PATH}resource/user/css/color_${this.resourceName}.css`, id: 'color' });
      }
      return links;
    }
  },

  watch: {
    // RoomMixinのresourceNameを監視し、変更があった場合vue-headを更新する
    resourceName(newValue: string, oldValue: string): void {
      if (newValue !== oldValue) this.$emit('updateHead');
    }
  },

  created(): void {
    // ログイン画面以外でリロードした時、storageからデータを取得しstateに設定する
    if (this.$route.name !== PublicRoutes.Login.name) this.loadRoomState();
  },

  methods: {
    createHtmlTitle(): string {
      if (this.isNormal) return 'まなびスタンプ';
      if (this.isBespra) return 'まなびスタンプ';
      if (this.isManabi) return 'まなびスタンプ';
      if (this.isGoogle) return 'まなびスタンプ';
      return 'まなびスタンプ';
    }
  }

});
